export default __webpack_public_path__ + "static/Korea-d95074ce7561cbb9f2f568ea00c50132.jpg";